import AuthHelper from 'features/Auth/authHelper';
import AppRoute from 'general/constants/AppRoute';
import { useRoutePermission } from 'hooks/useRoutePermission';
import _ from 'lodash';
import { Navigate } from 'react-router-dom';
import KTPageError01 from '../OtherKeenComponents/KTPageError01';
import { useSelector } from 'react-redux';

// Route yeu cau phai dang nhap
// Neu chua dang nhap nhay ve man hinh dang nhap '/sign-in'
function PrivateRoute(props) {
  // MARK: --- Params ---
  const isAuth = AuthHelper.checkAccessTokenValid() ?? false;
  const { user, agencyRoleList, permissionList } = useSelector((state) => state.auth);

  const { hasPermission, isPermissionReady } = useRoutePermission(user, agencyRoleList, permissionList);
  if (!isAuth) return <Navigate to={AppRoute.auth} />;

  if (_.isEmpty(user)) {
    return (
      <div className="d-flex min-vh-100 align-items-center justify-content-center">
        <div className="spinner-border text-success" role="status" aria-label="Loading profile" />
      </div>
    );
  }

  if (!isPermissionReady) {
    return (
      <div className="d-flex min-vh-100 align-items-center justify-content-center">
        <div className="spinner-border text-success" role="status" aria-label="Loading permissions" />
      </div>
    );
  }

  return hasPermission ? props.children : <KTPageError01 />;
}

export default PrivateRoute;
